import * as cpfHelp from '@/cpf.help';
import Help from '@/Help';
var Days;
(function (Days) {
    Days[Days["sun"] = 0] = "sun";
    Days[Days["mon"] = 1] = "mon";
    Days[Days["tue"] = 2] = "tue";
    Days[Days["wed"] = 3] = "wed";
    Days[Days["thu"] = 4] = "thu";
    Days[Days["fri"] = 5] = "fri";
    Days[Days["sat"] = 6] = "sat";
})(Days || (Days = {}));
export default class OpeningHours {
    static getSummary(data) {
        const now = new Date();
        const nowDay = Days[now.getDay()];
        if (data.openingHours[`${nowDay}Open`] && !data.openingHours[`${nowDay}24`] && (data.openingHours[`${nowDay}Opens`] === null || data.openingHours[`${nowDay}Closes`] === null)) {
            console.log("bad opening hours today : " + data.id); //TODO:TD deal with this server side
            return "Opening Hours Unknown";
        }
        let respVal = "";
        if (data.openingHours[`${nowDay}Open`]) {
            if (data.openingHours[`${nowDay}24`]) {
                respVal = "Open";
            }
            else {
                if (this.isOpenToday(data, now)) {
                    if (this.isClosingSoonToday(data, now)) {
                        respVal = "Closes Soon";
                    }
                    else {
                        respVal = "Open";
                    }
                }
                else if (this.isOpenYesterday(data, now)) {
                    if (this.isClosingSoonYesterday(data, now)) {
                        respVal = "Closes Soon";
                    }
                    else {
                        respVal = "Open";
                    }
                }
                else {
                    respVal = "Closed";
                }
            }
        }
        else {
            //closed today
            //could be open yesterday into today i.e. when it is open past midnight
            if (this.isOpenYesterday(data, now)) {
                if (this.isClosingSoonYesterday(data, now)) {
                    respVal = "Closes Soon";
                }
                else {
                    respVal = "Open";
                }
            }
            else {
                respVal = "Closed";
            }
        }
        return respVal;
    }
    static isOpenToday(data, now) {
        const nowDay = Days[now.getDay()];
        return this.isOpen(data, now, nowDay);
    }
    static isOpenYesterday(data, now) {
        const yesterday = this.addDays(now, -1);
        const yesterdayDay = Days[(now.getDay() - 1) % 7];
        if (data.openingHours[`${yesterdayDay}Open`] && !data.openingHours[`${yesterdayDay}24`]) {
            return this.isOpen(data, yesterday, yesterdayDay);
        }
        return false;
    }
    static isOpen(data, dateTime, day) {
        var dayOpensData = data.openingHours[`${day}Opens`];
        var dayClosesData = data.openingHours[`${day}Closes`];
        if (!Help.isGoodString(dayOpensData)) { //TODO:TD deal with this server side
            console.log(`cp id ${data.id} missing ${day}Opens`);
        }
        if (!Help.isGoodString(dayClosesData)) {
            console.log(`cp id ${data.id} missing ${day}Closes`);
        }
        if (Help.isGoodString(dayOpensData) && Help.isGoodString(dayClosesData)) {
            const dayOpens = this.convertToTime(dateTime, data.openingHours[`${day}Opens`]);
            let dayCloses = this.convertToTime(dateTime, data.openingHours[`${day}Closes`]);
            if (dayOpens >= dayCloses) { //This is for when closing time extends past midnight so we need to add 24 hours
                dayCloses += 86400000;
            }
            if (dateTime.getTime() > dayOpens && dateTime.getTime() < dayCloses) {
                return true;
            }
            return false;
        }
        return false;
    }
    static isClosingSoonToday(data, now) {
        const nowDay = Days[now.getDay()];
        return this.isClosingSoon(data, now, nowDay);
    }
    static isClosingSoonYesterday(data, now) {
        const yesterday = this.addDays(now, -1);
        const yesterdayDay = Days[(now.getDay() - 1) % 7];
        if (data.openingHours[`${yesterdayDay}Open`] && !data.openingHours[`${yesterdayDay}24`]) {
            return this.isClosingSoon(data, yesterday, yesterdayDay);
        }
        return false;
    }
    static isClosingSoon(data, dateTime, day) {
        if (this.isOpen(data, dateTime, day)) {
            const dayOpens = this.convertToTime(dateTime, data.openingHours[`${day}Opens`]);
            let dayCloses = this.convertToTime(dateTime, data.openingHours[`${day}Closes`]);
            if (dayOpens >= dayCloses) { //This is for when closing time extends past midnight so we need to add 24 hours
                dayCloses += 86400000;
            }
            if (dateTime.getTime() < dayCloses && (dayCloses - dateTime.getTime()) < 3600000) {
                return true;
            }
        }
        return false;
    }
    static isOpen24hours(data) {
        for (let i = 0; i < 7; i++) {
            if (!data.openingHours[`${Days[i]}24`]) {
                return false;
            }
        }
        return true;
    }
    static convertToTime(day, timeString) {
        let array = timeString.split(":").map(t => parseInt(t, 10));
        return new Date(day).setHours(array[0], array[1], 0, 0);
    }
    static getAllDayTimes(data) {
        if (this.isOpen24hours(data)) {
            return [{ day: "7 days", times: "24 Hrs" }];
        }
        let respVal = [];
        for (let i = 0; i < 7; i++) {
            if (!data.openingHours[`${Days[i]}Open`]) {
                respVal.push({ day: cpfHelp.capitalize(`${Days[i]}`), times: "Closed" });
            }
            else if (data.openingHours[`${Days[i]}24`]) {
                respVal.push({ day: cpfHelp.capitalize(`${Days[i]}`), times: "24 Hrs" });
            }
            else {
                const opens = data.openingHours[`${Days[i]}Opens`];
                const closes = data.openingHours[`${Days[i]}Closes`];
                respVal.push({ day: cpfHelp.capitalize(`${Days[i]}`), times: `${opens !== null ? opens.slice(0, -3) : "?"} - ${closes !== null ? closes.slice(0, -3) : "?"}` });
            }
        }
        return respVal;
    }
    static addDays(date, days) {
        let result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }
}
